// Bit Run Record — template + review checklist.
import { polishProse, MISSING } from "@/lib/ddr/templates";

const orMissing = (v) => (v && String(v).trim() ? String(v).trim() : MISSING);

export function buildBitRunReport(state) {
  const h = state.header || {};
  const b = state.bit || {};
  const bha = state.bha || {};
  const r = state.run || {};
  const p = state.params || {};
  const perf = state.performance || {};

  const lines = [];
  const push = (s) => { if (s !== null && s !== undefined) lines.push(s); };
  const sec = (label) => lines.push(`\n=== ${label.toUpperCase()} ===\n`);

  sec("Report Header");
  push(`Date: ${orMissing(h.reportDate)}`);
  push(`Rig: ${orMissing(h.rigName)}  ·  Well: ${orMissing(h.wellName)}`);
  push(`Operator / Client: ${orMissing(h.operator)}`);
  push(`Prepared By: ${orMissing(h.preparedBy)}`);

  sec("Bit Details");
  push(`Bit Number: ${orMissing(b.bitNumber)}  ·  Size: ${orMissing(b.bitSize)}`);
  push(`Type: ${orMissing(b.bitType)}  ·  Manufacturer: ${orMissing(b.manufacturer)}`);
  push(`IADC Code: ${orMissing(b.iadcCode)}  ·  Serial: ${orMissing(b.serial)}`);
  push(`Jets / Nozzles: ${orMissing(b.jets)}  ·  TFA: ${orMissing(b.tfa)}`);

  sec("BHA Summary");
  push(polishProse(bha.description) || MISSING);
  if (bha.motorRss) push(`Motor / RSS: ${bha.motorRss}`);
  if (bha.mwdLwd) push(`MWD / LWD Tools: ${bha.mwdLwd}`);
  if (bha.stabilizers) push(`Stabilizers: ${bha.stabilizers}`);

  sec("Run Summary");
  push(`Run In Depth: ${orMissing(r.runInDepth)}  ·  Pull Out Depth: ${orMissing(r.pullOutDepth)}`);
  push(`Interval Drilled: ${orMissing(r.intervalDrilled)}`);
  push(`Bit Hours: ${orMissing(r.bitHours)}  ·  Rotating Hours: ${orMissing(r.rotatingHours)}`);

  sec("Drilling Parameters");
  push(`WOB: ${orMissing(p.wob)}  ·  RPM: ${orMissing(p.rpm)}  ·  Torque: ${orMissing(p.torque)}`);
  push(`Flow Rate: ${orMissing(p.flowRate)}  ·  SPP: ${orMissing(p.spp)}  ·  Mud Weight: ${orMissing(p.mudWeight)}`);

  sec("Performance");
  push(`Average ROP: ${orMissing(perf.avgRop)}`);
  push(`Formation Drilled: ${orMissing(perf.formation)}`);

  sec("Dull Grade / Pull Reason");
  push(`Reason Pulled: ${orMissing(state.pull?.reason)}`);
  push(`Dull Grade (if available): ${orMissing(state.pull?.dullGrade)}`);

  sec("Lessons Learned / Recommendations");
  const notes = polishProse(state.notes?.roughNotes);
  if (notes) push(notes);
  else push(MISSING);
  const recs = polishProse(state.recommendations?.text);
  if (recs) push(`Recommendations: ${recs}`);

  return lines.join("\n");
}

export function bitReviewChecklist(state) {
  const out = [];
  const h = state.header || {};
  const b = state.bit || {};
  const r = state.run || {};
  if (!h.reportDate) out.push("Report date missing");
  if (!h.rigName) out.push("Rig name missing");
  if (!h.wellName) out.push("Well name missing");
  if (!h.preparedBy) out.push("Prepared-By missing");
  if (!b.bitSize) out.push("Bit size missing");
  if (!b.bitType) out.push("Bit type missing");
  if (!r.runInDepth) out.push("Run-in depth missing");
  if (!r.pullOutDepth) out.push("Pull-out depth missing");
  if (!r.bitHours) out.push("Bit hours missing");
  if (!state.pull?.reason) out.push("Reason pulled missing");
  return out;
}

export const BIT_QUICK_PHRASES = [
  "Bit performance within plan.",
  "Bit pulled on depth.",
  "Bit pulled on hours.",
  "Bit pulled due to ROP drop.",
  "Bit pulled for BHA change.",
  "Recommend same bit type next run.",
  "Recommend bit type change next run.",
  "No abnormal observations.",
];
